var _title, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRoundedJournal = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b057464c-c0c1-4deb-96bb-048237f2619a",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-rounded-journal-hollow")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    fill: "#333"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68748,19.80006H19.5",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,19.2V8.18756a2.1875,2.1875,0,0,1,2.18748-2.1875H20.5v11.625",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,22.00006H9.68748a2.1875,2.1875,0,0,1,0-4.375H20.5",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedJournal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-journal.ae74f435.svg";
export { ForwardRef as ReactComponent };